<script setup lang="ts">

</script>

<template>
  <div class="w-full h-screen bg-tw-1">
    <slot />
  </div>
</template>
